var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeauty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.762,
    height: 32.654,
    viewBox: "0 0 33.762 32.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hairdresser",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65325",
    "data-name": "Path 65325",
    d: "M23.35,3.275c.473-.075,5.153-.075,5.625,0,3.032.552,5.063,2.8,6.033,6.678a48.012,48.012,0,0,1,1.13,8.736l1.1-.069a49.692,49.692,0,0,0-1.162-8.935c-1.07-4.278-3.459-6.872-6.908-7.5-.534-.1-5.485-.1-6.019,0a7.63,7.63,0,0,0-4.224,2.248l.8.768A6.556,6.556,0,0,1,23.35,3.275Z",
    transform: "translate(-7.56 -0.05)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65326",
    "data-name": "Path 65326",
    d: "M33.548,34.846a1.662,1.662,0,0,0-1.66,1.66v.553h1.107v-.553a.553.553,0,1,1,1.107,0v.309a1.819,1.819,0,0,1-.368,1.095.8.8,0,0,1-.089.1c-.408.374-1.181.948-1.771.591-.573-.346-.78-1.866-.9-2.775-.032-.232-.061-.446-.092-.624l-1.091.187c.029.169.056.369.086.587a9.025,9.025,0,0,0,.64,2.631L26.932,38.4a3.56,3.56,0,0,1-3.346-3.55V29.3c1.546-1.834,2.265-4.5,2.889-6.835.228-.852.443-1.657.684-2.386a.551.551,0,0,0-.078-.5c-.45-.619-4.437-5.994-7.2-5.994l-.091,0a1.99,1.99,0,0,0-1.665,1.051c-1.537,2.561-7.942,4.776-8.007,4.8a.554.554,0,0,0-.353.677c.144.5.283,1.03.427,1.577.677,2.57,1.512,5.726,3.425,7.76v5.4A3.559,3.559,0,0,1,10.275,38.4l-3.581.211a9.025,9.025,0,0,0,.64-2.631c.03-.219.058-.418.086-.587.387-2.251.684-4.534.882-6.785.111-1.265.19-2.554.265-3.8.141-2.318.287-4.716.65-7.029L8.122,17.6c-.371,2.366-.519,4.79-.66,7.134-.076,1.239-.153,2.521-.263,3.771-.2,2.221-.488,4.473-.87,6.695-.031.179-.06.392-.092.624-.124.909-.331,2.429-.9,2.775-.334.2-.766.13-1.286-.21a1.9,1.9,0,0,1-.684-.848l-.084-.193a2.13,2.13,0,0,1-.173-.842.553.553,0,1,1,1.107,0v.553H5.321v-.553a1.66,1.66,0,1,0-3.321,0,3.206,3.206,0,0,0,.265,1.281l.084.193a2.991,2.991,0,0,0,1.094,1.334,2.772,2.772,0,0,0,1.357.5v.013l.1-.006.03,0a1.865,1.865,0,0,0,.241-.018l5.174-.3a4.666,4.666,0,0,0,4.388-4.654V30.4A6.663,6.663,0,0,0,18.6,31.528a6.312,6.312,0,0,0,3.874-1.188v4.506A4.667,4.667,0,0,0,26.867,39.5l5.138.3a1.925,1.925,0,0,0,.277.022l.043,0,.082,0v-.01a3.355,3.355,0,0,0,1.983-.99,1.885,1.885,0,0,0,.22-.243,2.939,2.939,0,0,0,.6-1.768v-.309a1.662,1.662,0,0,0-1.66-1.66ZM18.6,30.422c-4.959,0-6.222-4.79-7.336-9.016-.1-.376-.2-.745-.294-1.1,1.608-.6,6.616-2.617,8.105-5.1a.882.882,0,0,1,.764-.515c1.6-.06,4.548,3.13,6.176,5.312-.216.681-.41,1.409-.614,2.175-1.083,4.054-2.2,8.245-6.8,8.245Z",
    transform: "translate(0 -5.172)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65327",
    "data-name": "Path 65327",
    d: "M2.811,8.021a2.757,2.757,0,0,0,1.957.809,2.75,2.75,0,0,0,.4-.039,2.758,2.758,0,0,0,.77,2.36l.649.649a.553.553,0,0,0,.783,0l.649-.649a2.756,2.756,0,0,0,.77-2.36,2.828,2.828,0,0,0,.4.039,2.757,2.757,0,0,0,1.957-.809l.649-.649a.553.553,0,0,0,0-.783l-.649-.649a2.756,2.756,0,0,0-2.36-.77,2.758,2.758,0,0,0-.77-2.36l-.649-.649a.553.553,0,0,0-.783,0l-.649.649a2.756,2.756,0,0,0-.77,2.36,2.758,2.758,0,0,0-2.36.77l-.649.649a.553.553,0,0,0,0,.783Zm5.21-1.3a1.7,1.7,0,0,1,2.348,0l.257.257-.257.257a1.7,1.7,0,0,1-2.348,0l-.257-.257Zm-1.3-3.13.257-.257.257.257a1.661,1.661,0,0,1,0,2.348L6.981,6.2l-.257-.257a1.661,1.661,0,0,1,0-2.348Zm0,4.428.257-.257.257.257a1.661,1.661,0,0,1,0,2.348l-.257.257-.257-.257a1.661,1.661,0,0,1,0-2.348Zm-3.13-1.3a1.7,1.7,0,0,1,2.348,0l.257.257-.257.257a1.7,1.7,0,0,1-2.348,0l-.257-.257Z",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65328",
    "data-name": "Path 65328",
    d: "M54.8,36.59l-.649-.649a2.756,2.756,0,0,0-2.36-.77,2.758,2.758,0,0,0-.77-2.36l-.649-.649a.553.553,0,0,0-.783,0l-.649.649a2.756,2.756,0,0,0-.77,2.36,2.758,2.758,0,0,0-2.36.77l-.649.649a.553.553,0,0,0,0,.783l.649.649a2.648,2.648,0,0,0,2.36.77,2.758,2.758,0,0,0,.77,2.36l.649.649a.553.553,0,0,0,.783,0l.649-.649a2.756,2.756,0,0,0,.77-2.36,2.828,2.828,0,0,0,.4.039,2.757,2.757,0,0,0,1.957-.809l.649-.649A.553.553,0,0,0,54.8,36.59Zm-5.859.649a1.7,1.7,0,0,1-2.348,0l-.257-.257.257-.257a1.7,1.7,0,0,1,2.348,0l.257.257Zm1.3,3.13-.257.257-.257-.257a1.661,1.661,0,0,1,0-2.348l.257-.257.257.257a1.661,1.661,0,0,1,0,2.348Zm0-4.428-.257.257-.257-.257a1.661,1.661,0,0,1,0-2.348l.257-.257.257.257a1.661,1.661,0,0,1,0,2.348Zm3.13,1.3a1.7,1.7,0,0,1-2.348,0l-.257-.257.257-.257a1.7,1.7,0,0,1,2.348,0l.257.257Z",
    transform: "translate(-19.201 -13.396)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65329",
    "data-name": "Path 65329",
    d: "M52,2h1.107V3.107H52Z",
    transform: "translate(-22.327 0)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65330",
    "data-name": "Path 65330",
    d: "M54,4h1.107V5.107H54Z",
    transform: "translate(-23.22 -0.893)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65331",
    "data-name": "Path 65331",
    d: "M50,4h1.107V5.107H50Z",
    transform: "translate(-21.434 -0.893)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65332",
    "data-name": "Path 65332",
    d: "M52,6h1.107V7.107H52Z",
    transform: "translate(-22.327 -1.786)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65333",
    "data-name": "Path 65333",
    d: "M4,25H5.107v1.107H4Z",
    transform: "translate(-0.893 -10.27)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65334",
    "data-name": "Path 65334",
    d: "M6,27H7.107v1.107H6Z",
    transform: "translate(-1.786 -11.163)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65335",
    "data-name": "Path 65335",
    d: "M2,27H3.107v1.107H2Z",
    transform: "translate(0 -11.163)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65336",
    "data-name": "Path 65336",
    d: "M4,29H5.107v1.107H4Z",
    transform: "translate(-0.893 -12.056)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65337",
    "data-name": "Path 65337",
    d: "M58,12h1.107v1.107H58Z",
    transform: "translate(-25.006 -4.465)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65338",
    "data-name": "Path 65338",
    d: "M60,14h1.107v1.107H60Z",
    transform: "translate(-25.899 -5.358)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65339",
    "data-name": "Path 65339",
    d: "M56,14h1.107v1.107H56Z",
    transform: "translate(-24.113 -5.358)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65340",
    "data-name": "Path 65340",
    d: "M58,16h1.107v1.107H58Z",
    transform: "translate(-25.006 -6.252)",
    fill: "#06233d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeauty);
export default __webpack_public_path__ + "static/media/beauty.2f2ae47a2bfeeec60efa40c8d030e50b.svg";
export { ForwardRef as ReactComponent };